const STORAGE_KEY = 'veliora_wishlist';

function readWishlist() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    return [];
  }
}

function writeWishlist(items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items } }));
}

function isWishlisted(handle) {
  return readWishlist().some((item) => item.handle === handle);
}

function toggleWishlist(entry) {
  const items = readWishlist();
  const index = items.findIndex((item) => item.handle === entry.handle);
  if (index > -1) {
    items.splice(index, 1);
  } else {
    items.push(entry);
  }
  writeWishlist(items);
  return index === -1;
}

function escapeHtml(value) {
  const div = document.createElement('div');
  div.textContent = value == null ? '' : String(value);
  return div.innerHTML;
}

class WishlistButton extends HTMLElement {
  connectedCallback() {
    this.handle = this.dataset.handle;
    this.updateState();
    this._onClick = this.onClick.bind(this);
    this._onChange = this.updateState.bind(this);
    this.addEventListener('click', this._onClick);
    document.addEventListener('wishlist:change', this._onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);
    document.removeEventListener('wishlist:change', this._onChange);
  }

  onClick(event) {
    event.preventDefault();
    event.stopPropagation();
    toggleWishlist({
      handle: this.dataset.handle,
      title: this.dataset.title,
      image: this.dataset.image,
      price: this.dataset.price,
      url: this.dataset.url,
    });
  }

  updateState() {
    const active = isWishlisted(this.handle);
    this.classList.toggle('is-active', active);
    this.setAttribute('aria-pressed', active ? 'true' : 'false');
  }
}

if (!customElements.get('wishlist-button')) {
  customElements.define('wishlist-button', WishlistButton);
}

function updateHeaderCount() {
  const count = readWishlist().length;
  document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
    el.textContent = count > 0 ? String(count) : '';
    el.hidden = count === 0;
  });
}

function renderWishlistPage() {
  const grid = document.getElementById('wishlist-grid');
  if (!grid) return;

  const items = readWishlist();

  if (items.length === 0) {
    grid.innerHTML = '<p class="wishlist-empty">Your wishlist is empty. Browse our collections and tap the heart icon to save pieces you love.</p>';
    return;
  }

  grid.innerHTML = items
    .map(
      (item) => `
        <a href="${escapeHtml(item.url)}" class="wishlist-grid__item">
          <img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">
          <span class="wishlist-grid__title">${escapeHtml(item.title)}</span>
          <span class="wishlist-grid__price">${escapeHtml(item.price)}</span>
        </a>
      `
    )
    .join('');
}

function init() {
  updateHeaderCount();
  renderWishlistPage();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.addEventListener('wishlist:change', () => {
  updateHeaderCount();
  renderWishlistPage();
});
